import { usePresenceRoster } from '@byscott-io/where-is-waldo';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayout, MfaReminderBanner, PresenceBar } from '@byscott-io/corebyscott';

const navItems = [
  { path: '/app', label: 'Dashboard', icon: '🏠' },
  { path: '/app/recipes', label: 'Recipes', icon: '📖' },
  { path: '/app/meals', label: 'Meal Planner', icon: '📅' },
  { path: '/app/shopping', label: 'Shopping', icon: '🛒' },
  { path: '/app/household', label: 'Household', icon: '👥' },
  { path: '/app/admin', label: 'Admin', icon: '⚙️', adminOnly: true },
  { path: '/app/support', label: 'Support', icon: '🎫' },
];

// Who else from this organization is here right now. Mounted in the
// AUTHENTICATED layout only: a roster means nothing to a signed-out visitor,
// and a marketing page should not open a cable connection. Core cannot call
// waldo itself, so the roster is resolved here and passed in.
function OnlineNow() {
  const { online, connected } = usePresenceRoster();
  return <PresenceBar members={online} connected={connected} />;
}

export default function Layout({ children }) {
  const navigate = useNavigate();

  const handleMfaSetup = () => {
    navigate('/app/profile');
  };

  return (
    <>
      <OnlineNow />
    <AppLayout
      navItems={navItems}
      userInfoLink="/app/profile"
    >
      <MfaReminderBanner
        onSetupClick={handleMfaSetup}
        className="mb-4"
      />
      {children}
    </AppLayout>
    </>
  );
}
